import * as Usuario from './usuario';
import * as Cookie from './cookie';

export const Initialize = () => {

    
    Usuario.VerificarUsuario();
    
    
};

export const Login = () => {
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
}



function reMeHandler(res, token, xvalue)
{
    switch(res.code) {
        case "0000" :
            var usuario = JSON.parse(res.response);
            Cookie.SetXValue(xvalue);
            Cookie.SetToken(token);
            Cookie.SetupCookies(usuario.Usuario);
            break;
        
    }
};




// WEBPACK FOOTER //
// ./Statics/scripts/common/login.js